import { LengthUnit } from '../models/locker/enums/LengthUnit'

const COUNTRY_CODES_USING_LENGTH_UNIT_INCH = ['US', 'LR', 'MM']

export function openExternalUrl(url: string, onNewTab = false) {
  if (onNewTab) {
    window.open(url)
  } else {
    window.location.href = url
  }
}

export function getLengthUnitByCountryCode(
  countryCode: string | null | undefined,
) {
  if (
    countryCode &&
    COUNTRY_CODES_USING_LENGTH_UNIT_INCH.includes(countryCode)
  ) {
    return LengthUnit.UNIT_INCH
  }

  return LengthUnit.UNIT_CM
}
